import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule} from '@angular/forms'
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AreaComponent } from './widgets/area/area.component';
import { MatCardModule } from '@angular/material/card';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { AgmCoreModule } from '@agm/core'
import { TranslatePipe } from '../shared/pipes/translate.pipe';
import { AccumulationChartModule } from '@syncfusion/ej2-angular-charts';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    AreaComponent,
    TranslatePipe,
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    MatMenuModule,
    MatListModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HighchartsChartModule,
    MatExpansionModule,
    MatBadgeModule,
    MatCardModule,
    ToastModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatStepperModule,
    AccumulationChartModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBBmVRtHAjSVdUS4IaZHkbvKUMYI6Xmhuw'
    })
  ],
  exports:[
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    AreaComponent,
    TranslatePipe,
    AccumulationChartModule,
    
  ]
})
export class SharedModule { }
